import { CChartBar, CChartPie } from '@coreui/react-chartjs'
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import Loader from 'src/components/Loader'
import PlayerService from 'src/service/PlayerService'

const BarChart = () => {
  const [data, setData] = useState([])
  const [onesRangeData, setOnesRangeData] = useState([])
  const [twosRangeData, setTwosRangeData] = useState([])
  const [threesRangeData, setThreesRangeData] = useState([])
  const [fivesRangeData, setFivesRangeData] = useState([])
  const [sevensRangeData, setSevensRangeData] = useState([])
  const [eightsRangeData, setEightsRangeData] = useState([])
  const [ninesRangeData, setNinesRangeData] = useState([])
  const [outsRangeData, setOutsRangeData] = useState([])
  const [wksRangeData, setWksRangeData] = useState([])
  const [foursRangeData, setFoursRangeData] = useState([])
  const [sixesData, setSixesData] = useState([])
  const [mdnsData, setMdnsData] = useState([])
  const [fpsData, setFpsData] = useState([])
  const [csRangeData, setCsRangeData] = useState([])
  const [cwksRangeData, setCwksRangeData] = useState([])
  const [stsRangeData, setStsRangeData] = useState([])
  const [rodsRangeData, setRodsRangeData] = useState([])
  const [roasRangeData, setRoasRangeData] = useState([])
  const [dksRangeData, setDksRangeData] = useState([])
  const [noRangeData, setNoRangeData] = useState([])
  const [hattrickRangeData, setHattrickRangeData] = useState([])
  const [gameType, setGameType] = useState('')

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    PlayerService.getPlayerPieChartValue().then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setData(res.data)
        setGameType(res.gameType)
        setOnesRangeData(res.onesRangeData)
        setTwosRangeData(res.twosRangeData)
        setThreesRangeData(res.threesRangeData)
        setFivesRangeData(res.fivesRangeData)
        setSevensRangeData(res.sevensRangeData)
        setEightsRangeData(res.eightsRangeData)
        setNinesRangeData(res.ninesRangeData)
        setOutsRangeData(res.outsRangeData)
        setWksRangeData(res.wksRangeData)
        setFoursRangeData(res.foursRangeData)
        setSixesData(res.sixesRangeData)
        setMdnsData(res.mdnsRangeData)
        setFpsData(res.fpRangeData)
        setCsRangeData(res.csRangeData)
        setCwksRangeData(res.cwksRangeData)
        setStsRangeData(res.stsRangeData)
        setRodsRangeData(res.rodsRangeData)
        setRoasRangeData(res.roasRangeData)
        setDksRangeData(res.dksRangeData)
        setNoRangeData(res.noRangeData)
        setHattrickRangeData(res.hattrickRangeData)
        setLoading(false)
      }
    })
  }, [])
  // Extract keys and values from the backend data
  const dataValues = Object.values(data).map((value) => parseInt(value, 10))
  const dataOnesValues = Object.values(onesRangeData).map((value) => parseInt(value, 10))
  const dataTwosValues = Object.values(twosRangeData).map((value) => parseInt(value, 10))
  const dataThreesValues = Object.values(threesRangeData).map((value) => parseInt(value, 10))
  const dataFivesValues = Object.values(fivesRangeData).map((value) => parseInt(value, 10))
  const dataSevensValues = Object.values(sevensRangeData).map((value) => parseInt(value, 10))
  const dataEightsValues = Object.values(eightsRangeData).map((value) => parseInt(value, 10))
  const dataNinesValues = Object.values(ninesRangeData).map((value) => parseInt(value, 10))
  const dataOutsValues = Object.values(outsRangeData).map((value) => parseInt(value, 10))
  const dataWksValues = Object.values(wksRangeData).map((value) => parseInt(value, 10))

  const dataFoursValues = Object.values(foursRangeData).map((value) => parseInt(value, 10))
  const dataSixesValues = Object.values(sixesData).map((value) => parseInt(value, 10))
  const dataMdnsValues = Object.values(mdnsData).map((value) => parseInt(value, 10))
  const dataFpValues = Object.values(fpsData).map((value) => parseInt(value, 10))
  const dataCsValues = csRangeData
    ? Object.values(csRangeData).map((value) => parseInt(value, 10))
    : []
  const dataCwksValues = cwksRangeData
    ? Object.values(cwksRangeData).map((value) => parseInt(value, 10))
    : []
  const dataStsValues = stsRangeData
    ? Object.values(stsRangeData).map((value) => parseInt(value, 10))
    : []
  const dataRodsValues = rodsRangeData
    ? Object.values(rodsRangeData).map((value) => parseInt(value, 10))
    : []
  const dataRoasValues = roasRangeData
    ? Object.values(roasRangeData).map((value) => parseInt(value, 10))
    : []
  const dataDksValues = dksRangeData
    ? Object.values(dksRangeData).map((value) => parseInt(value, 10))
    : []
  const dataNoValues = noRangeData
    ? Object.values(noRangeData).map((value) => parseInt(value, 10))
    : []
  const dataHattrickValues = hattrickRangeData
    ? Object.values(hattrickRangeData).map((value) => parseInt(value, 10))
    : []

  const formattedData = {
    labels: ['1-9', '10-29', '30-49', '50-69', '70-89', '90-99', '100-149', '150-199', '200+ '],
    datasets: [
      {
        label: 'Runs Per Inning',
        backgroundColor: '#FF6384', // Adjust color as needed
        data: dataValues,
      },
    ],
  }

  const formattedOnesData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Ones Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataOnesValues,
      },
    ],
  }
  const formattedTwosData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Two Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataTwosValues,
      },
    ],
  }
  const formattedThreesData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Threes Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataThreesValues,
      },
    ],
  }
  const formattedFivesData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Fives Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataFivesValues,
      },
    ],
  }
  const formattedSevensData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Sevens Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataSevensValues,
      },
    ],
  }
  const formattedEightsData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Eights Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataEightsValues,
      },
    ],
  }
  const formattedNinesData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Nines Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataNinesValues,
      },
    ],
  }
  const formattedOutsData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Outs Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataOutsValues,
      },
    ],
  }
  const formattedWksData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Wickets Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataWksValues,
      },
    ],
  }
  const formattedFourData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Fours Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataFoursValues,
      },
    ],
  }
  const formattedSixesData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8-9', '21+'],
    datasets: [
      {
        label: 'Sixes Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataSixesValues,
      },
    ],
  }
  const formattedMdnsData = {
    labels: ['1-2', '3-4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
    datasets: [
      {
        label: 'Maidens Per Inning',
        backgroundColor: '#4BC0C0', // Adjust color as needed
        data: dataMdnsValues,
      },
    ],
  }
  const formattedFpData = {
    labels: ['1-50', '51-100', '101-150', '151-200', '201-300', '301-400', '401-500', '501+'],
    datasets: [
      {
        label: 'Fantasy Points Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataFpValues,
      },
    ],
  }

  const formattedCsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Catches Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataCsValues,
      },
    ],
  }
  const formattedCwksData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Catches (Wicket-Keeper) Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataCsValues,
      },
    ],
  }
  const formattedStsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Stumpings Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataCsValues,
      },
    ],
  }
  const formattedRodsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Run-Out Direct Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataRodsValues,
      },
    ],
  }
  const formattedRoasData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Run-Out Assisted Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataRoasValues,
      },
    ],
  }
  const formattedDksData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Duck Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataDksValues,
      },
    ],
  }
  const formattedNoData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Not Out Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataNoValues,
      },
    ],
  }
  const formattedHattrickData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+'],
    datasets: [
      {
        label: 'Hat-Trick Per Inning',
        backgroundColor: '#36A2EB', // Adjust color as needed
        data: dataHattrickValues,
      },
    ],
  }

  return loading ? (
    <Loader />
  ) : (
    <CRow>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Runs</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>

      {gameType === 3 && (
        <>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Ones</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedOnesData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Twos</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedTwosData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Threes</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedThreesData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>

          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Fours</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedFourData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Fives</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedFivesData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>

          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Sixes</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedSixesData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Sevens</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedSevensData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Eights</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedEightsData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Nines</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedNinesData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Outs</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedOutsData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
        </>
      )}
      {gameType !== 3 && (
        <>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Fours</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedFourData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol md={6}>
            <CCard className="mb-4">
              <CCardHeader>Sixes</CCardHeader>
              <CCardBody>
                <CCardBody>
                  <CChartBar data={formattedSixesData} labels="Runs Range" />
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCol>
        </>
      )}
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Wickets</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedWksData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Maidens</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedMdnsData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Fantasy Points</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedFpData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Catches</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedCsData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Catches (Wicket-Keeper)</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedCwksData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Stumpings</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedStsData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Run-Out Direct</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedRodsData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Run-Out Assisted</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedRoasData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Duck</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedDksData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Not Out</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedNoData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Hat-Trick</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedHattrickData} labels="Runs Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default BarChart
